import { createContext, useContext } from "react";
import useVoiceCall from "@/hooks/useVoiceCall";
import VoiceCallModal from "@/components/VoiceCallModal";

const VoiceCallContext = createContext(null);

/**
 * Mount once near the top of the app tree. Exposes the call state + actions
 * (via `useVoice()`) to any descendant, and always renders the full-screen
 * VoiceCallModal so incoming calls are surfaced anywhere in the app.
 */
export function VoiceCallProvider({ children }) {
  const call = useVoiceCall();
  return (
    <VoiceCallContext.Provider value={call}>
      {children}
      <VoiceCallModal call={call} />
    </VoiceCallContext.Provider>
  );
}

export function useVoice() {
  const ctx = useContext(VoiceCallContext);
  if (!ctx) throw new Error("useVoice must be used inside <VoiceCallProvider>");
  return ctx;
}
